import { REQUEST_TYPE_ACCESS, REQUEST_TYPE_GUARDING } from './value';
import { amendmentStartStep } from './amendmentStartStep';

/**
 * The form a request of a given type belongs to.
 *
 * Every flow that drops a user into a request form (amend, resubmit) has to
 * make this mapping, and each place that reimplemented it was one guarding
 * clause away from sending a guarding request to the visitor form — which is
 * exactly what resubmitting from the Last Booked Sites table used to do.
 *
 * Unknown / missing types fall back to the visitor form: it is the only chain
 * that starts with site selection, so it is the one that can recover if the
 * type is ever wrong.
 */
export const requestFormPath = (type: string | null | undefined): string => {
    if (type === REQUEST_TYPE_ACCESS) {
        return 'access-request';
    }
    if (type === REQUEST_TYPE_GUARDING) {
        return 'guarding-request';
    }

    return 'visitor-request';
};

/**
 * Form path plus the step that form opens on, for a request being amended or
 * resubmitted. Both walk the chain from the start, and retail reorders the
 * access and guarding chains — see amendmentStartStep for the step rules.
 */
export const requestFormRoute = (
    type: string | null | undefined,
    isRetail = false,
): { formPath: string, step: number } => ({
    formPath: requestFormPath(type),
    step: amendmentStartStep(type, isRetail),
});

export default requestFormRoute;
